export const themableMixin = {
  data () {
    return {
      themableBackgrounds: {
        Default: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/primary2_hero.png',
        Orange: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/secondary_hero.png',
        Gold: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/gold_hero.png',
        Pink: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/pink_hero.png',
        Blue: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/turquoise_hero.png',
        Purple: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/purple_hero.png',
        Gray: 'https://costuto-public.s3.eu-central-1.amazonaws.com/images/colors/gray_hero.png'

      },
      themableColorsPrimary: {
        Default: '#3ACFB9',
        Orange: '#DE6B48',
        Gold: '#fcba03',
        Pink: '#F1919B',
        Blue: '#579299',
        Purple: '#965C9C',
        Gray: '#92929A'
      },
      themableColorsLightPrimary: {
        Default: '#ADEBE2',
        Orange: '#EBCCAD',
        Gold: '#D69D00',
        Pink: '#F1919B',
        Blue: '#579299',
        Purple: '#965C9C',
        Gray: '#58585F'
      },
      themableColorsDarkPrimary: {
        Default: '#005C52',
        Orange: '#A03B1D',
        Gold: '#B28300',
        Pink: '#C74D59',
        Blue: '#325458',
        Purple: '#4D2F50',
        Gray: '#47474D'
      }
    }
  },
  computed: {
    themableStyle () {
      if (this.themableTheme) {
        return {
          '--hero-background': `linear-gradient(to right,     rgba(255, 255, 255, 1),
        rgba(255, 255, 255, 0.7),
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0.2),
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0.7),
        rgba(255, 255, 255, 1)), url(${this.themableBackgrounds[this.themableTheme]}) no-repeat center center fixed`,
          '--color-primary': `${this.themableColorsPrimary[this.themableTheme]}`,
          '--color-dark-primary': `${this.themableColorsDarkPrimary[this.themableTheme]}`,
          '--color-light-primary': `${this.themableColorsLightPrimary[this.themableTheme]}`
        }
      } else return null
    },

    // Override this in the implementing component
    themableTheme () {
      return null
    }
  }
}
